module.exports = __webpack_public_path__ + "img/idcardfront.180d4f8a.png";